import React, { Component } from 'react'
import ReactECharts from 'echarts-for-react'
import cfg from '../../../utils/config'
import auth from '../../../utils/auth'
import helper from '../../../utils/helper'
import moment from 'moment'
import axios from 'axios'

class GraficoLinha extends Component {
    rid = "chart-" + helper.randomKey(6)

    state = {
        chart: null,
        lastUpdate: null,
        params: {
            descricao: "",
            lines_chart: [],
            dates_chart: [],
            valores_anteriores: false,
            valor_minimo: false,
            valor_maximo: false
        }
    }

    componentDidMount = () => {
        const equipamentosData = Object.keys(this.props.equipamentosData)

        if(this.props.dataWidget && equipamentosData.length > 0) {
            this.getChartData(this.props.dataWidget)
        }
    }

    getChartData = (dataWidget) => {
        const { params } = this.state
        const { equipamentosData } = this.props
        const referencias = dataWidget.params?.referencias ?? []
        const valores_anteriores = dataWidget.params.valores_anteriores
        const supervisoryShared = dataWidget?.shared

        referencias.forEach((referencia) => {
            let imei_equipamento = referencia.parametro.equipamento.imei
            let id_parametro = referencia.parametro.id

            if(imei_equipamento in equipamentosData) {
                referencia['report_current'] = {
                    value: equipamentosData?.[imei_equipamento]?.[id_parametro],
                    date: (equipamentosData?.[imei_equipamento]?.['timestamp_dispositivo'] * 1000)
                }
            }
        })

        try {
            params.descricao = decodeURI(dataWidget['descricao'])
        } catch (e) {
            params.descricao = dataWidget['descricao']
        }
        params.valor_minimo = dataWidget.params.valor_minimo
        params.valor_maximo = dataWidget.params.valor_maximo
        params.periodo = dataWidget.params.periodo
        params.valores_anteriores = dataWidget.params.valores_anteriores
 
        if(valores_anteriores && !supervisoryShared) {
            this.getValoresAnteriores(dataWidget)
        } else {
            const { campo, equipamento, timestamp, value } = dataWidget
            const imei_parametro =  equipamento + "_" + campo

            params.lines_chart.push({
                name: imei_parametro,
                type: "line",
                data: [[this.convertTimezone(timestamp, 'DD/MM/YYYY HH:mm:ss'), value]]
            })

            params.dates_chart.push(timestamp)

            if(referencias.length > 0) {
                referencias.forEach((referencia) => {
                    const imei_parametro = referencia.parametro.equipamento.imei + "_" + referencia.parametro.id

                    params.lines_chart.push({
                        name: imei_parametro,
                        type: "line",
                        data: [[this.convertTimezone(referencia.report_current.date, 'DD/MM/YYYY HH:mm:ss'), referencia.report_current.value]],
                        color: referencia.cor
                    })

                    params.dates_chart.push(referencia.report_current.date)
                })
            }

            params.dates_chart = [...new Set(params.dates_chart)].sort((a, b) => a - b)

            this.setState({ params })

            this.updateChart(params.dates_chart, params.lines_chart)
        }
    }

    getValoresAnteriores = (dataWidget) => {
        const { mqtt, campo, params } = dataWidget
        const referencias = params?.referencias ?? []
        const mqtt_params = {}
        const colors_referencias = {}

        mqtt_params[mqtt] = [campo]

        if(referencias.length > 0) {
            referencias.forEach(referencia => {
                const imei_referencia = referencia.parametro.equipamento.imei
                const mqtt_referencia = referencia.parametro.equipamento.usuario_mqtt
                const parametro = referencia.parametro.id

                colors_referencias[imei_referencia + "_" + parametro] = referencia.cor

                if(mqtt_referencia in mqtt_params) {
                    if(!mqtt_params[mqtt_referencia].includes(parametro)) {
                        mqtt_params[mqtt_referencia].push(parametro)
                    }
                } else {
                    mqtt_params[mqtt_referencia] = [parametro]
                }
            })
        }

        const userInfo = auth.getUserInfo()

        const periodo_exibicao = {
            "1": 3600,
            "3": 10800,
            "6": 21600,
            "12": 43200,
            "24": 86400
        }

        const data = {
            equipamentos_ids_parametros: [],
            horas_historico_em_segundos: dataWidget.params.periodo ? periodo_exibicao[dataWidget.params.periodo] : false
        }

        for(let mqtt in mqtt_params) {
            const parametros = mqtt_params[mqtt].join()

            data.equipamentos_ids_parametros.push({ equipamento_id: mqtt, parametros: parametros })
        }

        axios({
            url: `${cfg.base_api_url + cfg.api_v2}/${userInfo.empresa}/supervisorio/historico/equipamentos/`,
            method: "POST",
            data: data,
            headers: { 'Authorization': 'Bearer ' + auth.getToken() }
        })
        .then((res) => {
            const { params } = this.state
            const { data } = res 

            data.series.forEach((line) => {
                if(line.name in colors_referencias) {
                    line["color"] = colors_referencias[line.name]
                }
            })

            data.categories = data.categories.map((timestamp) => timestamp * 1000)

            params.lines_chart = data.series
            params.dates_chart = data.categories

            this.setState({ params })
            this.updateChart(data.categories, data.series)
        })
    }

    componentWillReceiveProps = (nextProps) => {
        let { lastUpdate } = this.state

        try {
            if (new Date().getTime() - lastUpdate > 60_000) {
                let { params } = this.state
                let { equipamentosData } = this.props

                params.lines_chart.forEach((line) => {
                    let [imei, ...parametro] = line.name.split("_")
                    parametro = parametro.join("_")
                    const report = equipamentosData[imei] ?? false

                    if(report) {
                        const report_date = this.convertTimezone(report["timestamp_dispositivo"] * 1000, 'DD/MM/YYYY HH:mm:ss')
                        const parametro_value = report[parametro]
                        const new_item = [report_date, parametro_value]

                        const contain_item = line.data.some((item) => item[0] == report_date && item[1] == parametro_value)

                        if(!contain_item) {
                            line.data.push(new_item)
                            params.dates_chart.push(report["timestamp_dispositivo"] * 1000)
                        }
                    }
                })

                params.dates_chart = [...new Set(params.dates_chart)].sort((a, b) => a - b)

                if (params.periodo && params.dates_chart.length > 0) {
                    let dateHour = (params.periodo ?? 1) * 60

                    if (params.dates_chart.length >= dateHour) {
                        const date = params.dates_chart[0]

                        params.lines_chart.forEach((line) => {
                            line.data = line.data.filter((item) => item[0] != date)
                        })

                        params.dates_chart.shift()
                    }
                }

                this.setState({ params })

                this.updateChart(params.dates_chart, params.lines_chart)
            }
        } catch (err) {
            console.error(err)
        }
    }

    updateChart = (dates, linesChart) => {
        let { params } = this.state
        let series = []

        series = [...linesChart]

        if (Boolean(Number.parseInt(params.valor_minimo))) {
            let minData = []
            dates.forEach(v => minData.push(params.valor_minimo))
            series.push({ type: 'line', data: minData, name: "Valor Mínimo", color: "#44dba6" })
        }

        if (Boolean(Number.parseInt(params.valor_maximo))) {
            let maxData = []
            dates.forEach(v => maxData.push(params.valor_maximo))
            series.push({ type: 'line', data: maxData, name: "Valor Máximo", color: "#d48a3b" })
        }

        const options = {
            legend: { show: true, type: "scroll" },
            series: series,
            xAxis: {
                data: dates.map((timestamp) => this.convertTimezone(timestamp, 'DD/MM/YYYY HH:mm:ss')),
                nameTextStyle: { fontWeight: '600', fontSize: '12' },
                nameLocation: 'center',
                nameGap: 25
            },
            yAxis: { type: 'value' },
            dataZoom: [
                {
                    type: 'inside',
                    xAxisIndex: 0,
                    filterMode: 'none'
                }
            ],
            tooltip: {
                show: true,
                trigger: "axis",
                axisPointer: { label: { show: true } },
            },
            grid: { left: 55, top: 50, right: 14, bottom: 5 }
        }

        this.setState({ chart: null })
        setTimeout(() => {
            try {
                const parent = document.querySelector(`#${this.rid}`).parentElement
                const style = { height: `${parent.clientHeight - 80}px`, width: '100%', marginTop: '10px' }

                this.setState({
                    lastUpdate: new Date().getTime(),
                    chart: <ReactECharts option={options} style={style} />
                })
            } catch (err) { }
        }, 10)
    }

    convertTimezone = (dataUTC, format) => {
        const systemTZ = Intl.DateTimeFormat().resolvedOptions().timeZone
        try {
            let timezone = auth.getUserInfo()?.timezone ?? this.props.timezone
            if (!timezone) {
                timezone = systemTZ
            }

            return moment.tz(dataUTC, 'UTC').tz(timezone).format(format)
        } catch (err) {
            return moment.tz(new Date().getTime(), 'UTC').tz(systemTZ).format(format)
        }
    }

    render() {

        return (
            <div className="hdv-bloco-informacao hdv-chart-bloco-reactgridlayout">
                {this.props.dataWidget?.ultimoEvento({ showUnity: false })}
                <div id={this.rid}>
                    {this.state.chart}
                </div>
            </div>
        )
    }
}

export default GraficoLinha